
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

export default function BrandSlider({ brands = [], top = 10 }) {

    if (!brands || brands.length === 0) {
        return <div style={{ height: "58px", marginTop: '50px' }} />;
    }

    const duplicatedBrands = brands.length < 8
        ? [...brands, ...brands, ...brands, ...brands]
        : [...brands, ...brands];

    return (
        <div style = {{ width: "100%", marginTop: `${top}px` }}>
            <style>{`
                .swiper-wrapper {
                    transition-timing-function: linear !important;
                }
            `}</style>
            <Swiper
                modules = {[Autoplay, FreeMode]}
                spaceBetween = {10}
                slidesPerView = "auto"
                loop = {true}
                speed = {4000}
                allowTouchMove = {false}
                freeMode = {true}
                autoplay = {{
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                }}
            >
                {duplicatedBrands.map((brand, index) => (
                    <SwiperSlide
                        key = {`${brand.id || index}-${index}`}
                        style = {{
                            width: "auto",
                            display: 'flex',
                            alignItems: "center"
                        }}
                    >
                        <div
                            style = {{
                                display: "flex",
                                border: '1px solid #EEEEEE',
                                borderRadius: "50px",
                                padding: "8px 20px",
                            }}
                        >
                            <img
                                src = {process.env.REACT_APP_STORAGE_URL + brand.logo}
                                alt = {brand.name || "brand"}
                                style = {{ height: "40px" }}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}